import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

export const PublicLayout = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: { offset: -80 } });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  return (
    <div className="grain min-h-screen bg-sand font-body text-ink">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
